import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a546c53"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "expansion-panel" }
const _hoisted_2 = { class: "panel-header__title" }
const _hoisted_3 = {
  key: 0,
  class: "expansion-panel__content"
}

import GoogleMaterialIcon from '../../helper-components/google-material-icon/google-material-icon.vue';
import { reactive } from 'vue';
import { IExpansionPanelProps } from './expansion-panel.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'expansion-panel',
  props: {
    props: null
  },
  setup(__props: any) {



const state = reactive({
    isExpanded: false,
});

let onHeaderClicked = () => {
    state.isExpanded = !state.isExpanded;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "expansion-panel__header panel-header",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onHeaderClicked) && _unref(onHeaderClicked)(...args)))
    }, [
      _createVNode(GoogleMaterialIcon, {
        class: "panel-header__icon",
        props: {
                    iconName: state.isExpanded ? 'expand_less' : 'expand_more',
                }
      }, null, 8, ["props"]),
      _createElementVNode("p", _hoisted_2, _toDisplayString(__props.props.title), 1)
    ]),
    _createVNode(_Transition, {
      name: "expansion-panel-content-transition",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (state.isExpanded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "default")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})